//@mui
import { Box, Typography, useTheme, Grid } from "@mui/material";
import { BrandsTile } from "../brandTile";
import useCollapseDrawer from "~src/hooks/useCollapseDrawer";
import { FullBrand } from "~src/types/brand";
import usePermissions from "~src/hooks/usePermissions";

export default function CompetitorComparison({
  fullBrand,
}: {
  fullBrand: FullBrand[];
}) {
  const theme = useTheme();
  const { isCollapse } = useCollapseDrawer();
  const { premiumCommunity } = usePermissions();

  if (!fullBrand || fullBrand.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: theme.palette.grey[200],
        borderRadius: "12px",
        background: theme.palette.common.white,
        p: 3,
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography
          sx={{
            mb: 3,
            fontSize: { xs: 16, md: 30 },
            fontWeight: 500
          }}>
          Competitors
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {fullBrand?.map((item, index) => {
          return (
            <Grid  size={{ xs: 12, md: isCollapse ? 2.4 : 2.4 }} >
              <BrandsTile
                competitor={item}
                index={index}
                lock={
                  !premiumCommunity && (index === 3 || index === 4)
                    ? true
                    : false
                }
              />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}
